///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'winde-highlight-text',
    template: `<span [innerHTML]="displayName()"></span>`
})
export class HighlightTextComponent {
    public text = input<string>();
    public searchSubstring = input<string>();

    public displayName = computed(() => {
        if (!this.text() || !this.searchSubstring() || !this.text().toLowerCase().includes(this.searchSubstring().toLowerCase())) {
            return this.text();
        }

        const firstAppearance = this.text().toLowerCase().indexOf(this.searchSubstring().toLowerCase());
        const replacePart = this.text().substring(firstAppearance, firstAppearance + this.searchSubstring().length);

        return `${this.text().substring(0, firstAppearance)}<span class="highlight-substring">${replacePart}</span>${this.text().substring(
            firstAppearance + this.searchSubstring().length
        )}`;
    });
}
